import type { ActionSignup } from '../providers/sandbox-actions';
import Button from '@atlaskit/button';
import { css } from '@emotion/react';
import { ExtensionParams } from '@atlaskit/editor-common/dist/types/extensions/types/extension-handler';

const extensionImageMap: { [extensionKey: string]: string } = {
  roadmap: require(`../../assets/images/roadmap-planner.svg`)
};

const container = css`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  transition: box-shadow 0.35s;
  z-index: 1;

  :hover img {
    box-shadow: 2px 5px 25px -4px rgba(0, 0, 0, 0.35);
    filter: blur(2px);
  }

  :hover button {
    display: inline-block;
  }

  :focus {
    box-shadow: 2px 5px 25px -4px rgba(0, 0, 0, 0.35);
    filter: blur(2px);
  }
`;

const btn = () =>
  css({
    'minWidth': 128,
    'border': '1px solid #0052cc',
    'margin': 6,
    'height': 32,
    'lineHeight': '30px',
    'textAlign': 'center',
    'cursor': 'pointer',
    'padding': '0 16px',
    'fontSize': '.875rem',
    'fontWeight': '500 !important',
    'color': '#f4f5f7',
    'zIndex': 2,
    ':hover': {
      color: '#f4f5f7'
    },
    'position': 'absolute',
    'top': '40%',
    'left': '40%',
    'display': 'none'
  });

export const fakeExtension =
  (signup: ActionSignup) =>
  // eslint-disable-next-line react/display-name
  ({ extensionKey }: ExtensionParams<object>) => {
    const extensionImage = extensionImageMap[extensionKey];
    if (!extensionImage) {
      return null;
    }

    return (
      <>
        <div css={container}>
          <img height={445} src={extensionImage} alt="extension" />
          <Button appearance="primary" onClick={() => signup()} css={btn()}>
            {'Sign up to edit'}
          </Button>
        </div>
      </>
    );
  };
